import { useEffect } from "react";
import { motion } from "framer-motion";
import contactImage from "../assets/IMG_2807.WEBP";

export default function Contact() {
  useEffect(() => {
    if ("scrollRestoration" in window.history)
      window.history.scrollRestoration = "manual";
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);
  const fadeLeft = {
    hidden: { opacity: 0, x: -40 },
    show: { opacity: 1, x: 0, transition: { duration: 0.6, ease: "easeOut" } },
  };
  const fadeRight = {
    hidden: { opacity: 0, x: 40 },
    show: { opacity: 1, x: 0, transition: { duration: 0.6, ease: "easeOut" } },
  };
  return (
    <section className="container py-16 ">
      <h1 className="text-4xl md:text-5xl font-bold mb-8">Contact</h1>
      <div className="grid lg:grid-cols-2 gap-8 items-stretch">
        <motion.div
          variants={fadeLeft}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          className="relative rounded-xl overflow-hidden min-h-[50vh]"
        >
          <img
            src={contactImage}
            alt="Travel support"
            className="absolute inset-0 w-full h-full object-cover "
          />
          <div className="absolute inset-0 bg-gradient-to-tr from-black/40 via-black/20 to-transparent" />
        </motion.div>
        <motion.div
          variants={fadeRight}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          className="card p-6 md:p-8 flex flex-col gap-5"
        >
          <p className="text-gray-600">
            We’d love to help plan your next trip. Reach out for inquiries about
            visas, flights, hotels, or custom tour packages.
          </p>
          <div>
            <div className="text-sm uppercase tracking-wide text-gray-500">
              Email
            </div>
            <a
              href="mailto:blacktech2255@gmail.com"
              className="text-2xl font-semibold"
            >
              blacktech2255@gmail.com
            </a>
          </div>

          <div>
            <div className="text-sm uppercase tracking-wide text-gray-500">
              Phone
            </div>
            <a href="tel:+971050523316" className="text-2xl font-semibold">
              +9710505237316
            </a>
          </div>
          <div className="flex flex-wrap items-center gap-4">
            <motion.a
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.98 }}
              href="https://wa.me/9710505237316"
              target="_blank"
              rel="noreferrer"
              className="btn-primary inline-flex items-center gap-2"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path
                  d="M20.52 3.48A11.94 11.94 0 0 0 12 0C5.37 0 0 5.37 0 12c0 2.11.54 4.1 1.56 5.88L0 24l6.3-1.64A11.94 11.94 0 0 0 12 24c6.63 0 12-5.37 12-12 0-3.21-1.25-6.23-3.48-8.52ZM12 22a9.9 9.9 0 0 1-5.05-1.39l-.36-.21-3.6.94.96-3.5-.24-.38A9.96 9.96 0 1 1 22 12c0 5.52-4.48 10-10 10Zm5.14-7.36c-.28-.14-1.65-.81-1.9-.9s-.44-.14-.62.14c-.18.28-.71.9-.86 1.08-.16.18-.32.2-.6.07-.28-.14-1.18-.43-2.24-1.38-.83-.74-1.39-1.65-1.55-1.93-.16-.28-.02-.43.12-.57.12-.12.28-.32.42-.49.14-.16.18-.28.28-.46.1-.18.05-.34-.02-.49-.07-.14-.62-1.49-.85-2.05-.22-.53-.45-.46-.62-.46h-.53c-.18 0-.46.07-.7.34-.24.28-.92.9-.92 2.2 0 1.3.95 2.56 1.08 2.74.14.18 1.88 2.87 4.56 4.02.64.28 1.14.45 1.53.58.64.2 1.22.17 1.68.1.51-.08 1.65-.67 1.89-1.31.24-.64.24-1.18.17-1.31-.07-.13-.26-.2-.54-.34Z"
                  fill="currentColor"
                />
              </svg>
              <span>Chat on WhatsApp</span>
            </motion.a>
            <div className="flex items-center gap-3">
              <motion.a
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.96 }}
                href="https://facebook.com"
                target="_blank"
                rel="noreferrer"
                aria-label="Facebook"
                className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 transition"
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M22 12.06C22 6.48 17.52 2 11.94 2S2 6.48 2 12.06C2 17.08 5.66 21.22 10.44 22v-7.02H7.9v-2.92h2.54V9.41c0-2.5 1.49-3.88 3.77-3.88 1.09 0 2.23.2 2.23.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56v1.87h2.78l-.44 2.92h-2.34V22C18.34 21.22 22 17.08 22 12.06Z" />
                </svg>
              </motion.a>
              <motion.a
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.96 }}
                href="https://instagram.com"
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
                className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 transition"
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M7 2C4.24 2 2 4.24 2 7v10c0 2.76 2.24 5 5 5h10c2.76 0 5-2.24 5-5V7c0-2.76-2.24-5-5-5H7Zm10 2c1.66 0 3 1.34 3 3v10c0 1.66-1.34 3-3 3H7c-1.66 0-3-1.34-3-3V7c0-1.66 1.34-3 3-3h10Zm-5 3.5A5.5 5.5 0 1 0 17.5 13 5.51 5.51 0 0 0 12 7.5Zm0 9A3.5 3.5 0 1 1 15.5 13 3.5 3.5 0 0 1 12 16.5ZM18 6.2a.8.8 0 1 0 .8.8.8.8 0 0 0-.8-.8Z" />
                </svg>
              </motion.a>
            </div>
          </div>
          <div className="text-sm text-gray-500">
            We typically respond within 1–2 business hours.
          </div>
        </motion.div>
      </div>
    </section>
  );
}
